module.exports = __webpack_public_path__ + "static/media/assignment_turned_in-24px.1f14a0bc.svg";